/* eslint camelcase: 0 */
import { AlgoliaGatewayBase } from './base'
import { toHits, toQueryProps } from './translator/query'
import { toCompanyProps } from '@/gateways/Monitaro/translator/company'
import { FetchCompany } from '@/infrastructure/network/Algolia/requests/company'
import { IQueryProps } from '@/entities/Query'

export default class Company extends AlgoliaGatewayBase {
  async clearCache() {
    await this.apiClient.clearCache(new FetchCompany().index)
  }

  async FetchCompany(query: IQueryProps) {
    const response = await this.apiClient.request(new FetchCompany(query.word, toHits(query)))
    return {
      items: response.hits!.map((prop) => toCompanyProps(prop)),
      query: toQueryProps(response)
    }
  }
}
